export default {
  title: 'ประวัติกล้องจดจำป้าย',
  filter: {
    label: 'ตัวกรอง',
    active_count: 'เลือก {{count}} รายการ',
    vehicle: 'ยานพาหนะ',
    all_vehicles: 'ทุกคัน',
    direction: 'ทิศทาง',
    direction_all: 'ทั้งหมด',
    direction_in: 'เข้า',
    direction_out: 'ออก',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    apply: 'ใช้ตัวกรอง',
    clear: 'ล้าง',
  },
  card: {
    vehicle_id: 'ยานพาหนะ',
    plate: 'ป้ายทะเบียน',
    direction: 'ทิศทาง',
    score: 'คะแนนจับคู่',
    status: 'สถานะ',
    view_capture: 'ดูภาพ',
    no_plate: '—',
  },
  lightbox: {
    title: 'ภาพจากกล้อง',
    front: 'ด้านหน้า',
    rear: 'ด้านหลัง',
    no_image: 'ไม่มีภาพ',
    close: 'ปิด',
  },
  status: {
    verified_success: 'ยืนยันแล้ว',
    verified_failed: 'ไม่ตรงกัน',
    pending: 'รอดำเนินการ',
  },
  direction: {
    in: 'เข้า',
    out: 'ออก',
    unknown: 'ไม่ระบุ',
  },
  no_events: 'ไม่พบประวัติกล้อง',
  no_events_sub: 'ลองปรับตัวกรองหรือตรวจสอบในภายหลัง',
  page_of: '{{page}} / {{total}}',
  loading: 'กำลังโหลด…',
}
